import { ComponentPropsWithoutRef, ReactNode } from 'react';
import { SearchHit } from 'api/search';
import { SearchResultMark } from 'components/search/SearchResultMark';
import { get } from 'lodash';
import { NestedPath } from 'types/util';

interface SearchHitHighlightOrDocumentValueProps<T>
    extends Omit<ComponentPropsWithoutRef<'p'>, 'children'> {
    hit: SearchHit<T>;
    documentKey: NestedPath<T>;
}

const SearchHitHighlightOrDocumentValue = <T,>(
    props: SearchHitHighlightOrDocumentValueProps<T>,
) => {
    const { hit, documentKey, ...rest } = props;
    const possibleHighlight = get(hit.highlight, documentKey);
    const documentValue = get(hit.document, documentKey);

    if (possibleHighlight) {
        return <SearchResultMark {...rest}>{possibleHighlight.snippet}</SearchResultMark>;
    }

    return <p {...rest}>{documentValue as ReactNode}</p>;
};

export { SearchHitHighlightOrDocumentValue };
export type { SearchHitHighlightOrDocumentValueProps };
